<script>
  import { onMount } from 'svelte';
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();

  export let current = 1,
    valueText;

  const min = 0,
    max = 1,
    step = 0.01;
  let sliding = false,
    slider,
    scale;

  onMount(() => {
    scale = slider.clientWidth / (max / step);
    function handleResize() {
      scale = slider.clientWidth / (max / step);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  $: dispatch('change', { value: current });

  function handleMouseMove(e) {
    if (sliding) {
      const distance = e.clientX - slider.getBoundingClientRect().left;
      const value = Math.round(distance / scale) * step;
      current = Math.max(Math.min(value, max), min);
    }
  }

  async function handleMouseDown(e) {
    sliding = true;
    const distance = e.clientX - slider.getBoundingClientRect().left;
    const value = Math.round(distance / scale) * step;
    current = Math.max(Math.min(value, max), min);
  }

  function handleKeydown(e) {
    if (e.keyCode === 37 || e.keyCode === 40) {
      e.preventDefault();
      const nextValue = current - step;
      current = Math.max(nextValue, min);
    } else if (e.keyCode === 38 || e.keyCode === 39) {
      e.preventDefault();
      const nextValue = current + step;
      current = Math.min(nextValue, max);
    }
  }

  function handleMouseup(e) {
    sliding = false;
  }
</script>

<style>
  .volume-slider-wrapper {
    width: 110px;
    display: inline-block;
    vertical-align: top;
  }

  .slider {
    position: relative;
    width: 100px;
    height: 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .rail {
    width: 100%;
    height: 8px;
    background-color: #aaa;
    border-radius: 5px;
    overflow: hidden;
  }

  .fill {
    width: 100%;
    height: 8px;
    background-color: #fff;
    transform-origin: left;
    transform: scaleX(0);
  }

  .ball {
    position: absolute;
    z-index: 2;
    top: calc(50% - 8px);
    left: -3px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #fff;
  }
</style>

<svelte:body
  on:mousemove={handleMouseMove}
  on:mouseup={handleMouseup}
  on:mouseleave={handleMouseup} />
<div class="volume-slider-wrapper">
  <div
    tabindex="0"
    aria-valuemax={max}
    aria-valuemin={min}
    aria-valuenow={current}
    aria-valuetext={valueText}
    aria-orientation="horizontal"
    role="slider"
    bind:this={slider}
    class="slider"
    on:mousedown={handleMouseDown}
    on:keydown={handleKeydown}>
    <div class="rail">
      <div class="ball" style="left: calc({(current / max) * 100}% - 8.5px)" />
      <div class="fill" style="transform: scaleX({current / max})" />
    </div>
  </div>
</div>
